import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import axios from "axios";
import BASE_URL from "../utils/Urls";
import KeypadModal from "./KeypadModal";
import ConfirmModal from "./ConfirmModal";

const fmt = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

const PaymentSettlePopup = ({ row, onClose, onSettled }) => {
  const [showKeypad, setShowKeypad] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const due = Number(row.paymentDue) || 0;

  const settle = async () => {
    setSubmitting(true);
    try {
      const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser") || "null");
      await axios.post(`${BASE_URL}/admin/settle-payment/${row.user_id}`, {
        updated_by: loggedInUser?.username || loggedInUser?.name || "admin",
      });
      setShowConfirm(false);
      onSettled?.();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to settle payment.");
      setShowConfirm(false);
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
        <div className="bg-white rounded-lg shadow-lg relative p-6" style={{ width: "420px" }}>
          <button onClick={onClose} className="absolute top-3 right-5 text-red-600 hover:text-red-800">
            <IoClose className="text-2xl" />
          </button>
          <h2 className="text-center font-bold text-xl text-gray-800 mb-1">Settle payment</h2>
          <p className="text-center text-xs text-gray-400 mb-4">{row.employer_name || row.user_id}</p>

          <div className="border rounded-lg p-4 text-center mb-4">
            <div className="text-xs text-gray-400">PAYMENT DUE</div>
            <div className="text-3xl font-bold text-[#FF0707]">{fmt(due)}</div>
          </div>
          <p className="text-xs text-gray-500 text-center mb-4">
            Settling marks this due as paid, adds it to banked earnings, and records an account statement.
          </p>

          <div className="flex justify-center">
            <button
              onClick={() => setShowKeypad(true)}
              disabled={due <= 0 || submitting}
              className={`font-bold py-3 px-10 rounded-full shadow-lg text-white ${
                due <= 0 ? "bg-gray-300 cursor-not-allowed" : "bg-gradient-to-r from-purple-800 to-pink-600"
              }`}
              style={{ border: "2px solid gold" }}
            >
              {due <= 0 ? "Nothing due" : "PAYMENT SETTLED"}
            </button>
          </div>
        </div>
      </div>

      {showKeypad && (
        <KeypadModal
          type="secondary"
          onGoClick={() => {
            setShowKeypad(false);
            setShowConfirm(true);
          }}
          onClose={() => setShowKeypad(false)}
        />
      )}
      {showConfirm && <ConfirmModal onYes={settle} onNo={() => setShowConfirm(false)} />}
    </>
  );
};

export default PaymentSettlePopup;
